import React from 'react';

function TaskFilters({ currentFilter, onFilterChange }) {
  const filters = [
    { value: 'all', label: 'All Tasks' },
    { value: 'Not Started', label: 'Pending' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' }
  ];

  return (
    <div className="flex space-x-2">
      {filters.map(filter => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          className={`px-4 py-2 rounded-lg text-sm ${
            currentFilter === filter.value
              ? 'bg-blue-500 text-white'
              : 'bg-white text-gray-600 hover:bg-gray-50'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}

export default TaskFilters;